export default "__VITE_ASSET__1dc0438b__"